import axios from 'axios';
import { ScriveGroupActionModel } from '@/types';

const GroupActionsApiUrl = 'scriveworkflowjob/groupAction';

export const ScriveWorkflowJobService = {
  async GroupActionsAsync(queueId: number, dataSource: ScriveGroupActionModel) {
    await axios.post(`${GroupActionsApiUrl}/${queueId}`, dataSource);
  }
};
